export var HANDOFF_OPENED = '000006068817';
export var SIGN_UP_THROUGH_PLAYER = '000009658864';
